import { render, staticRenderFns } from "./AccountTransactionFormModal.vue?vue&type=template&id=80974534&scoped=true&"
import script from "./AccountTransactionFormModal.vue?vue&type=script&lang=js&"
export * from "./AccountTransactionFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80974534",
  null
  
)

export default component.exports